import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { AppBar, Container, Toolbar, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import styleConstants from "../../../../constants/styles";
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        appbar: {
            backgroundColor: "#fff",
        },
        toolbar: (_a = {
                backgroundColor: "#fff",
                boxShadow: "0 0.5px 0 0 #ddd"
            },
            _a[theme.breakpoints.up("sm")] = {
                paddingLeft: 24,
                paddingRight: 24,
            },
            _a),
        avatar: {
            width: 35,
            height: 35,
        },
        text: {
            marginRight: 2,
            display: "flex",
            fontFamily: styleConstants.fontFamily.headerFontFamily,
            fontWeight: 100,
            color: styleConstants.color.headerFont,
            fontSize: styleConstants.fontSize.headerFontSize,
            textDecoration: "none",
            paddingLeft: 10,
            paddingRight: 10,
        },
    });
});
var PlaceholderText = function (_a) {
    var text = _a.text;
    var style = {
        height: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
    return (React.createElement(Container, { style: style },
        React.createElement(Typography, { align: "center", style: { color: "#666" }, variant: "h4" }, text)));
};
export var LinkinBioNotFound = function (_a) {
    var errorMsg = _a.errorMsg, handlerName = _a.handlerName;
    var styles = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar, { position: "static", elevation: 0, className: styles.appbar },
            React.createElement(Toolbar, { className: styles.toolbar },
                React.createElement(Skeleton, { variant: "circle", className: styles.avatar }),
                React.createElement(Typography, { noWrap: true, className: styles.text }, handlerName))),
        React.createElement(Container, { maxWidth: "md" },
            React.createElement(PlaceholderText, { text: errorMsg }))));
};
